export const removeSingleParam = (url = "") => {
  return url.split("/").slice(0, -1).join("/");
};
